@if (useDS) {
    @if (showErrors() && getMessage(); as message) {
        <ds-help-group>
            <ds-help-item type="error" inverse="false" [isRightAligned]="false">
                <span [innerHtml]="message | trustAsHtml" slot="text"></span>
            </ds-help-item>
        </ds-help-group>
    }
    @if (showSuccess()) {
        @if (showErrors() && getMessage(); as message) {
            <ds-help-group>
                <ds-help-item type="success" inverse="false" [isRightAligned]="false">
                    <span [innerHtml]="message | trustAsHtml" slot="text"></span>
                </ds-help-item>
            </ds-help-group>
        }
    }
} @else {
    @if (showErrors() && getMessage(); as message) {
        <div class="custom-error m2-validation-messages theme-error-i">
            <span class="m2-validation-message" [innerHtml]="message | trustAsHtml"></span>
        </div>
    }
    @if (showSuccess()) {
        <div class="m2-validation-messages theme-success-i">
            @if (showErrors() && getMessage(); as message) {
                <span class="m2-validation-message" [innerHtml]="message | trustAsHtml"></span>
            }
        </div>
    }
}
